import { useAttributtesByIdQuery } from 'queries/attributes/queries';
import { useGetSensorsByEventId, useGetSensorsByModelName } from 'queries/sensors';

const useSensorsTags = (
  tagsBy: 'model' | 'asset' | 'event',
  assetId: string,
  modelName?: string,
  eventId?: string,
) => {
  const tagsByEventQuery = useGetSensorsByEventId(eventId, {
    enabled: tagsBy === 'event' && !!eventId,
  });
  const tagsByModelQuery = useGetSensorsByModelName(modelName, {
    enabled: tagsBy === 'model' && !!modelName,
  });
  const tagsByAssetQuery = useAttributtesByIdQuery(assetId, {
    enabled: tagsBy === 'asset',
  });

  switch (tagsBy) {
    case 'model':
      return { tags: tagsByModelQuery.data, isLoading: tagsByModelQuery.isFetching };
    case 'event':
      return { tags: tagsByEventQuery.data, isLoading: tagsByEventQuery.isFetching };
    default:
      return { tags: tagsByAssetQuery.data, isLoading: tagsByAssetQuery.isFetching };
  }
};

export default useSensorsTags;
